import React, {
  useState,
  useEffect,
  forwardRef,
  Fragment,
  useImperativeHandle,
  useRef,
} from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Badge, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { connect, useDispatch } from "react-redux";
import { Row, Col, Card, Tab, Nav, Button } from "react-bootstrap";
import {
  addCandidates,
  getCandidatesJob,
  getCandidateById,
  updateCandidates,
  getCandidates,
} from "../../../store/actions/Candidates/candidateActions";
import { withRouter } from "../../../App";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import { industrySector } from "../../constant/industrySector";
import { countries } from "../../constant/country";
import { visaTypes } from "../../constant/visaTypes";
import {
  getCompanyById,
  getCompanyContactById,
  updateCompany,
} from "../../../store/actions/Companies/companyActions";
import TableData from "./TableData";
import { dateFormat } from "../../../utils/date";
import EmailLog from "../Common/EmailLog";
import AddCompanyContact from "./AddCompanyContact";
import { del } from "../../../services/api";
import swal from "sweetalert";
import EditCompanyContact from "./EditCompanyContact";
import Jobs from "./Jobs";
import { getCompanyJob } from "../../../store/actions/Jobs/jobActions";
import { debounce } from "../../../utils/debounce";
import ViewContactLog from "../Common/ViewContactLog";
import ResitrictCandidates from "./ResitrictCandidates";

const AddCompanyMaster = ({
  token,
  selectedCompany,
  companyContacts,
  companySources,
  natureOfBusiness,
  companyContactsPeople
}) => {
  const [query, setQuery] = useState(""); // User's input
  const [results, setResults] = useState([]); // API results
  const [sourceList, setSourceList] = useState([]);
  const [natureOfBusinessList, setNatureOfBusinessList] = useState([]);

  useEffect(() => {
    if (companySources) {
      setSourceList(companySources?.map((itm) => itm.value));
    }
  }, [companySources]);

  const handleSuggestionClick = async (suggestion) => {
    const apiData = await fetch(
      `https://api.getaddress.io/${suggestion.url}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();

    // Destructure and rewrap into a new variable `address`
    const address = {
      addressLine1: result.line_1 || "",
      addressLine2: result.line_2 || "",
      addressLine3: result.line_3 || "",
      town: result.town_or_city || "",
      county: result.county || "",
      country: result.country || "",
      postcode: result.postcode || "",
      region: result.region || "",
    };

    // Update the form data with the new address details
    setFormData((prevFormData) => ({
      ...prevFormData,
      address,
    }));
    // setFormData({ ...formData, [field]: value });
    setResults([]); // Clear suggestions after selection
  };

  const fetchData = async (searchTerm) => {
    const apiData = await fetch(
      `https://api.getaddress.io/autocomplete/${searchTerm}?api-key=pdSw7G1TEk6kghR1DNzddQ41182&all=true`
    );
    const result = await apiData.json();
    setResults(result.suggestions);
    console.log(results);
  };

  // Handle input changes
  const handlePostCodeQueryChange = (inputQuery) => {
    setQuery(inputQuery); // Update input state
    debounce(fetchData(inputQuery)); // Call the debounced function
  };

  const [showEditContactModal, setShowEditContactModal] = useState(false);
  const [selectedContact, setSelectedContact] = useState({});
  const companyContactRef = useRef();
  const [searchParams] = useSearchParams();
  const updateCompanyId = searchParams.get("id");
  const formMode = searchParams.get("mode");

  const isView = formMode === "view";
  const nav = useNavigate();
  // useEffect(() => {
  //   dispatch(getCandidatesJob(token));
  // }, []);
  useEffect(() => {
    dispatch(getCandidates(token));
  }, []);
  useEffect(() => {
    if (updateCompanyId) {
      dispatch(getCompanyById(updateCompanyId, token));
      dispatch(getCompanyContactById(updateCompanyId, token));
      dispatch(getCompanyJob(updateCompanyId, token));
      if(natureOfBusiness) {
        setNatureOfBusinessList(natureOfBusiness?.map((itm) => itm.value));
      }
    }
  }, [updateCompanyId, natureOfBusiness]);

  const tabData = [
    {
      name: "Master",
      icon: "home",
    },
    {
      name: "Business",
      icon: "info-circle",
    },
    {
      name: "People",
      icon: "certificate",
    },
    {
      name: "Jobs",
      icon: "info",
    },
    {
      name: "Email Log",
      icon: "envelope",
    },
    {
      name: "Contact Log",
      icon: "phone",
    },
    {
      name: "Restrict Candidates",
      icon: "users",
    },
  ];
  const dispatch = useDispatch();
  const contactLogRef = useRef();
  const [formData, setFormData] = useState({
    companyName: "",
    address: {
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      town: "",
      county: "",
      country: "",
      postcode: "",
      region: "",
    },
    contact: {
      office: "",
    },
    email: "",
    website: "",
    business: "Rapid Resourcing Ltd",
    office: "Liverpool",
    sector: "",
    clientId: "",
    consultant: "",
    regDate: null,
    source: "",
    lastContactDate: null,
    statusDate: null,
    status: "CLIENT",
    subsidiaryRecords: [],
    businessRecords: [],
    peopleRecords: [],
    natureOfBusiness: "",
    companyRegNo: "",
    regEndDate: null,
    currentRecruitmentMethod: "",
  });

  useEffect(() => {
    setFormData({
      ...selectedCompany,
      addressLine1: selectedCompany?.address?.[0]?.addressLine1 || "",
      addressLine2: selectedCompany?.address?.[0]?.addressLine2 || "",
      town: selectedCompany?.address?.[0]?.town || "",
      county: selectedCompany?.address?.[0]?.county || "",
      country: selectedCompany?.address?.[0]?.country || "",
      postCode: selectedCompany?.address?.[0]?.postcode || "",
      region: selectedCompany?.address?.[0]?.region || "",
      regDate: selectedCompany.regDate
        ? new Date(selectedCompany.regDate)
        : null,
      lastContactDate: selectedCompany.lastContactDate
        ? new Date(selectedCompany.lastContactDate)
        : null,
      statusDate: selectedCompany.statusDate
        ? new Date(selectedCompany.statusDate)
        : null,
      regEndDate: selectedCompany?.regEndDate
        ? new Date(selectedCompany.regEndDate)
        : null,
    });
  }, [selectedCompany]);

  const [errors, setErrors] = useState({});
  const [activeTab, setActiveTab] = useState(tabData[0].name.toLowerCase()); // Set initial active tab

  const handleSelect = (key) => {
    setActiveTab(key);
    console.log("key", key);
  };
  const validate = () => {
    const newErrors = {};
    if (activeTab === "master") {
      const requiredFields = ["companyName", "clientId", "status"];

      requiredFields.forEach((field) => {
        if (!formData[field]?.trim()) {
          newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
        }
      });

      const addressRequiredFields = [
        "addressLine1",
        "town",
        "country",
        "postcode",
        // "region",
      ];
      addressRequiredFields.forEach((field) => {
        if (!formData?.address?.[field]?.trim()) {
          newErrors[field] = `${field.replace(/([A-Z])/g, " $1")} is required.`;
        }
      });

      if (!formData.contact.office?.trim()) {
        newErrors.office = "Please enter Company Telephone Number.";
      }
      if (
        formData.contact.office && 
        !/^(?:\+44|0)\d{10}$/.test(formData.contact.office)
      ) {
        newErrors.office = "Company Telephone Number must be a valid UK number.";
      }

      if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Email must be valid.";
      }
    }

    if (activeTab === "business") {
      if (!formData.natureOfBusiness?.trim()) {
        newErrors.natureOfBusiness = "Please select nature of business.";
      }
      // if (!formData.companyRegNo?.trim()) {
      //   newErrors.companyRegNo = "Please enter company registration number.";
      // }
      // if (!formData.regEndDate) {
      //   newErrors.regEndDate = "Please select registration end date.";
      // }
      // if (!formData.currentRecruitmentMethod?.trim()) {
      //   newErrors.currentRecruitmentMethod =
      //     "Please enter current recruitment methods.";
      // }
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      console.log(newErrors, "I am here..");
      toast.error("Please fill all required fields.");
    }

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field, value, nested = null) => {
    if (field === "postcode") {
      handlePostCodeQueryChange(value);
    }
    if (nested) {
      setFormData((prev) => ({
        ...prev,
        [nested]: { ...prev[nested], [field]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      const { __v, _id, ...payload } = formData;
      if (selectedCompany?._id) {
        payload.email = payload.email?.toLowerCase();
        dispatch(updateCompany(payload, () => {}, selectedCompany?._id, token));
      } else {
        //dispatch(addCandidates(payload, () => { }, token));
      }
    }
  };
  /**
   * people actions
   */
  return (
    <>
      <Fragment>
        <div className="container-fluid">
          <div className="col-xl-12 col-lg-12">
            <div className="card profile-card card-bx m-b30 p-4">
              <Tab.Container activeKey={activeTab} onSelect={handleSelect}>
                <Nav as="ul" className="nav-tabs">
                  {tabData.map((data, i) => (
                    <Nav.Item as="li" key={i}>
                      <Nav.Link eventKey={data.name.toLowerCase()}>
                        <i className={`la la-${data.icon} me-2`} />
                        {data.name}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
                <Tab.Content className="pt-4">
                  <Tab.Pane eventKey="master" key={1}>
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Company Name <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            disabled={isView}
                            className="form-control"
                            value={formData.companyName || ""}
                            onChange={(e) =>
                              handleInputChange("companyName", e.target.value)
                            }
                          />
                          {errors.companyName && (
                            <small className="text-danger">
                              {errors.companyName}
                            </small>
                          )}
                        </div>

                        {[
                          {
                            label: "Address Line 1",
                            field: "addressLine1",
                            required: true,
                          },
                          { label: "Address Line 2", field: "addressLine2" },
                          { label: "Address Line 3", field: "addressLine3" },
                          { label: "Town", field: "town", required: true },
                          { label: "County", field: "county" },
                          {
                            label: "Country",
                            field: "country",
                            required: true,
                          },
                          {
                            label: "Postcode",
                            field: "postcode",
                            required: true,
                          },
                          // { label: "Source", field: "source", required: false, type:"select",  options: [ "Word of Mouth", "Recommendation", "Press", "Socials", "Other"]},
                        ].map(({ label, field, required = false }) => (
                          <div className="col-xl-6 mb-3" key={field}>
                            <label className="form-label">
                              {label}{" "}
                              {required && (
                                <span className="text-danger">*</span>
                              )}
                            </label>
                            <input
                              type="text"
                              disabled={isView}
                              className="form-control"
                              value={formData?.address?.[field] || ""}
                              onChange={(e) =>
                                handleInputChange(
                                  field,
                                  e.target.value,
                                  "address"
                                )
                              }
                            />
                            {field === "postcode" && results?.length > 0 && (
                              <div
                                style={{
                                  border: "1px solid #ccc",
                                  borderRadius: "5px",
                                  maxHeight: "150px", // Medium size scrollable div
                                  overflowY: "auto",
                                  marginTop: "5px",
                                  padding: "10px",
                                  backgroundColor: "#fff",
                                }}
                              >
                                {results?.map((suggestion, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      padding: "5px",
                                      cursor: "pointer",
                                      borderBottom: "1px solid #eee",
                                    }}
                                    onClick={() =>
                                      handleSuggestionClick(suggestion)
                                    } // Handle click on suggestion
                                  >
                                    {suggestion.address}
                                  </div>
                                ))}
                              </div>
                            )}
                            {errors[field] && (
                              <small className="text-danger">
                                {errors[field]}
                              </small>
                            )}
                          </div>
                        ))}
                        {/* Source */}
                        <div className="col-xl-6 mb-3">
                          <label className="form-label">Source </label>
                          <select
                            className="form-control form-select"
                            value={formData.source}
                            disabled={isView}
                            onChange={(e) =>
                              handleInputChange("source", e.target.value)
                            }
                          >
                            <option value=""></option>
                            {sourceList?.map((itm) => (
                              <option value={itm}>{itm}</option>
                            ))}
                          </select>
                        </div>
                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Company Telephone Number{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            disabled={isView}
                            className="form-control"
                            value={formData?.contact?.office || ""}
                            onChange={(e) =>
                              handleInputChange(
                                "office",
                                e.target.value,
                                "contact"
                              )
                            }
                          />
                          {errors.office && (
                            <small className="text-danger">
                              {errors.office}
                            </small>
                          )}
                        </div>

                        {[
                          { label: "Email", field: "email", type: "email" },
                          { label: "Website", field: "website", type: "text" },
                          // { label: "Sector", field: "sector", type: "text" },
                        ].map(({ label, field, type }) => (
                          <div className="col-xl-6 mb-3" key={field}>
                            <label className="form-label">{label}</label>
                            <input
                              type={type}
                              disabled={isView}
                              className="form-control"
                              value={formData?.[field] || ""}
                              onChange={(e) =>
                                handleInputChange(field, e.target.value)
                              }
                            />
                            {errors[field] && (
                              <small className="text-danger">
                                {errors[field]}
                              </small>
                            )}
                          </div>
                        ))}

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Client ID <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            disabled
                            className="form-control"
                            value={formData?.clientId || ""}
                          />
                          {errors.clientId && (
                            <small className="text-danger">
                              {errors.clientId}
                            </small>
                          )}
                        </div>

                        {[
                          { label: "Registration Date", field: "regDate" },
                          // {
                          //   label: "Last Contact Date",
                          //   field: "lastContactDate",
                          // },
                          // { label: "Status Date", field: "statusDate" },
                        ].map(({ label, field }) => (
                          <div className="col-xl-6 mb-3" key={field}>
                            <label className="form-label">{label}</label>
                            <DatePicker
                              dateFormat="dd/MM/yyyy"
                              disabled={isView}
                              className="form-control"
                              selected={formData?.[field] || ""}
                              onChange={(date) =>
                                handleInputChange(field, date)
                              }
                            />
                          </div>
                        ))}

                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Status <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control"
                            disabled={isView}
                            value={formData?.status || ""}
                            onChange={(e) =>
                              handleInputChange("status", e.target.value)
                            }
                          >
                            <option value=""></option>
                            <option value="CLIENT">CLIENT</option>
                            <option value="PROSPECT">PROSPECT</option>
                            <option value="ARCHIVED">ARCHIVED</option>
                          </select>
                          {errors.status && (
                            <small className="text-danger">
                              {errors.status}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="card-footer">
                        {isView ? null : (
                          <button
                            type="submit"
                            className="btn btn-primary me-1"
                          >
                            Save
                          </button>
                        )}
                        <button
                          type="button"
                          onClick={() => nav("/companies")}
                          className="btn btn-danger light ms-1"
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </Tab.Pane>

                  <Tab.Pane eventKey="business" key={2}>
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Nature of Business{" "}
                            <span className="text-danger">*</span>
                          </label>
                          {/* <input
                            type="text"
                            className="form-control"
                            disabled={isView}
                            value={formData.natureOfBusiness}
                            onChange={(e) =>
                              handleInputChange(
                                "natureOfBusiness",
                                e.target.value
                              )
                            }
                          /> */}
                          <select
                            className="form-control"
                            value={formData.natureOfBusiness}
                            disabled={isView}
                            onChange={(e) =>
                              handleInputChange(
                                "natureOfBusiness",
                                e.target.value
                              )
                            }
                          >
                            <option value="">Select Nature of Business</option>
                            {natureOfBusinessList.map((itm)=>(
                            <option value={itm}>
                              {itm}
                            </option>))}
                            
                          </select>
                          {errors.natureOfBusiness && (
                            <small className="text-danger">
                              {errors.natureOfBusiness}
                            </small>
                          )}
                        </div>
                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Company RegNo.
                          </label>
                          <input
                            type="text"
                            disabled={isView}
                            className="form-control"
                            value={formData.companyRegNo}
                            onChange={(e) =>
                              handleInputChange("companyRegNo", e.target.value)
                            }
                          />
                          {errors.companyRegNo && (
                            <small className="text-danger">
                              {errors.companyRegNo}
                            </small>
                          )}
                        </div>
                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Reg. EndDate
                          </label>
                          <DatePicker
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                            disabled={isView}
                            selected={formData.regEndDate}
                            onChange={(date) =>
                              handleInputChange("regEndDate", date)
                            }
                          />
                          {/* <input
                            type="date"
                            disabled={isView}
                            className="form-control"
                            onChange={(e) =>
                              handleInputChange("regEndDate", e.target.value)
                            }
                            value={formData.regEndDate}
                          /> */}
                          {errors.regEndDate && (
                            <small className="text-danger">
                              {errors.regEndDate}
                            </small>
                          )}
                        </div>
                        <div className="col-xl-6 mb-3">
                          <label className="form-label">
                            Current recruitment methods
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            disabled={isView}
                            onChange={(e) =>
                              handleInputChange(
                                "currentRecruitmentMethod",
                                e.target.value
                              )
                            }
                            value={formData.currentRecruitmentMethod}
                          />
                          {errors.currentRecruitmentMethod && (
                            <small className="text-danger">
                              {errors.currentRecruitmentMethod}
                            </small>
                          )}
                        </div>
                        {formData?.subsidiaryRecords?.length > 0 && (
                          <div className="col-xl-12 mb-3">
                            <label className="form-label">
                              Subsidiary records
                            </label>
                            <div>
                              {formData?.subsidiaryRecords?.map(
                                (record, index) => (
                                  <Fragment key={index}>
                                    <Badge
                                      onClick={(e) => {
                                        nav(
                                          `/add-company?id=${record.companyId}&mode=edit`
                                        );
                                      }}
                                      bg="primary"
                                    >
                                      {record?.companyName}
                                    </Badge>{" "}
                                    &nbsp;
                                  </Fragment>
                                )
                              )}
                            </div>
                          </div>
                        )}
                        {!formData?.isParent && (
                          <div className="col-xl-12 mb-3">
                            <label className="form-label">Parent Company</label>
                            <div>
                              <Fragment
                                key={formData?.parentCompanyDetails?.companyId}
                              >
                                <Badge
                                  onClick={(e) => {
                                    nav(
                                      `/add-company?id=${formData?.parentCompanyDetails.companyId}&mode=edit`
                                    );
                                  }}
                                  bg="primary"
                                >
                                  {formData?.parentCompanyDetails?.companyName}
                                </Badge>{" "}
                                &nbsp;
                              </Fragment>
                            </div>
                          </div>
                        )}
                        <TableData
                          businessRecords={formData?.businessRecords}
                        />
                      </div>
                      <div className="card-footer">
                        {!isView ? (
                          <button
                            type="submit"
                            className="btn btn-primary light ms-1"
                          >
                            Save
                          </button>
                        ) : (
                          <>&nbsp;</>
                        )}
                        <button
                          type="button"
                          onClick={() => setActiveTab("master")}
                          className="btn btn-danger light ms-1"
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </Tab.Pane>

                  <Tab.Pane eventKey="people" key={3}>
                    <div>
                      {!isView && (
                        <button
                          className="btn btn-danger mb-3"
                          onClick={() => {
                            companyContactRef.current.showContactModal();
                          }}
                        >
                          <i className="fa fa-plus"></i> Add Contact
                        </button>
                      )}

                      <form onSubmit={handleSubmit}>
                        <Table responsive className="table table-responsive">
                          <thead>
                            <tr>
                              <th>
                                <strong>Name</strong>
                              </th>
                              <th>
                                <strong>Position</strong>
                              </th>
                              <th>
                                <strong>Contact Type</strong>
                              </th>
                              <th>
                                <strong>Phone</strong>
                              </th>
                              {/* <th>
                                <strong>Status</strong>
                              </th> */}
                              {/* <th>
                                <strong>Category</strong>
                              </th> */}
                              {!isView && <th>Action</th>}
                            </tr>
                          </thead>
                          <tbody>
                            {companyContactsPeople?.length === 0 && (
                              <tr>
                                <td colSpan={6}>No result found.</td>
                              </tr>
                            )}
                            {companyContactsPeople?.map((row, index) => (
                              <tr key={index}>
                                <td>
                                  <strong>
                                    {row?.title} {row?.firstName}{" "}
                                    {row?.lastName}
                                  </strong>
                                </td>
                                <td>{row?.currentPosition || "--"}</td>
                                <td>{row?.position || "--"}</td>
                                <td>{row?.contact?.phoneNumber}</td>
                                {/* <td>{row?.status}</td> */}
                                {/* <td>{row?.category}</td> */}
                                {!isView && (
                                  <td>
                                    <div className="d-flex">
                                      <>
                                        <button
                                          type="button"
                                          className="btn btn-primary shadow btn-xs sharp me-1"
                                          onClick={() => {
                                            setSelectedContact(row);
                                            setShowEditContactModal(true);
                                          }}
                                        >
                                          <i className="fas fa-pencil-alt"></i>
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-danger shadow btn-xs sharp"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            swal({
                                              title: "Are you sure?",
                                              text: "Once deleted, you will not be able to recover this company contact!",
                                              icon: "warning",
                                              buttons: true,
                                              confirmButtonText: "Delete",
                                              dangerMode: true,
                                            }).then(async (willDelete) => {
                                              if (willDelete) {
                                                await del(
                                                  "/api/company-contacts/" +
                                                    row?._id,
                                                  token
                                                );
                                                toast.success(
                                                  "Company contact deleted successully."
                                                );
                                                dispatch(
                                                  getCompanyContactById(
                                                    updateCompanyId,
                                                    token
                                                  )
                                                );
                                              } else {
                                              }
                                            });
                                          }}
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </>
                                    </div>
                                  </td>
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                        <div className="card-footer">
                          &nbsp;
                          <button
                            type="button"
                            onClick={() => setActiveTab("master")}
                            className="btn btn-danger light ms-1"
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                    {showEditContactModal && (
                      <EditCompanyContact
                        showEditContactModal={showEditContactModal}
                        setShowEditContactModal={setShowEditContactModal}
                        selectedContact={selectedContact}
                        token={token}
                      />
                    )}
                  </Tab.Pane>
                  <Tab.Pane eventKey="email log" key={4}>
                    <EmailLog
                      token={token}
                      emailList={companyContactsPeople.map((c) => c.email)}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="jobs" key={5}>
                    <Jobs isView={isView} />
                  </Tab.Pane>
                  <Tab.Pane eventKey="contact log" key={3}>
                    <ViewContactLog
                      contactLogRef={contactLogRef}
                      token={token}
                      contactPersonId={updateCompanyId}
                    />
                  </Tab.Pane>
                  <Tab.Pane eventKey="restrict candidates" key={1}>
                    <ResitrictCandidates />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
      </Fragment>
      <AddCompanyContact
        ref={companyContactRef}
        companyId={updateCompanyId}
        Title="Add Company Contact"
        token={token}
        companyContacts={companyContacts}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    selectedCompany: state.companies.selectedCompany,
    companyContactsPeople: state.companies.companyContacts,
    companySources: state?.dropDownValues?.dropDownValues?.companySources || [],
    natureOfBusiness: state?.dropDownValues?.dropDownValues?.natureOfBusiness || [],
    companyContacts: state?.dropDownValues?.dropDownValues?.companyContacts || [],
  };
};

export default withRouter(connect(mapStateToProps)(AddCompanyMaster));
